/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import 'react-datepicker/dist/react-datepicker.css';
import { titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import { getLoadTypeText } from '../../../load/Loads';

import { sluggify } from '../../../../utils/localization/utils';

const getInitialState = (props) => {
  const { stops: shipmentStops, loads: shipmentLoads } = props;
  const stops = shipmentStops.map((stop) => {
    return {
      action: titleize(stop.action === 'deliver' ? 'delivery' : stop.action),
      loads: stop.loads || [],
    };
  });

  return { stops };
};

class LoadDistributionModal extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState(props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props !== newProps) {
      this.setState(getInitialState(newProps));
    }
  }

  onLoadQuantityChange(stops, stopIndex, loadIndex, value) {
    const stopLoad = { ...stops[stopIndex].loads[loadIndex] };
    const shipmentLoad = this.props.loads[loadIndex];
    stopLoad.quantity = parseInt(value || 0, 10);
    stopLoad.weight = parseInt(
      (
        (shipmentLoad.weight * stopLoad.quantity) /
        shipmentLoad.quantity
      ).toFixed(0),
      10,
    );
    stops[stopIndex].loads[loadIndex] = stopLoad;
    this.setState({ stops });
  }

  render() {
    const { loads: shipmentLoads, t } = this.props;
    const { stops } = this.state;

    return (
      <Modal show={this.props.show} enforceFocus={false}>
        <Modal.Header>
          <h5>{t('LOAD_DISTRIBUTION')}</h5>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <div className="pl-4 py-2 font-bold">{t('OVERALL_CARGO')}</div>
              <ul>
                {shipmentLoads.map((l, i) => {
                  return (
                    <li className="pl-4" key={i}>{`${l.quantity} ${t(
                      getLoadTypeText(l.type),
                      { count: 2 },
                    )} ${l.length}x${l.width}x${l.height} ${l.weight} ${t(
                      sluggify(l.weight_units),
                    )}`}</li>
                  );
                })}
              </ul>
            </div>
            <div className="flex flex-col">
              <div className="flex flex-row pt-4 pb-2 font-bold">
                <div className="pl-4 w-1/3">{t('STOP', { count: 1 })}</div>
                <div className="w-2/3">{t('LOAD_DISTRIBUTION')}</div>
              </div>
              {stops.map((stop, stopIndex) => {
                return stop.loads.map((l, i) => {
                  return (
                    <div>
                      <div className="flex flex-row" key={i}>
                        <div className="pl-4 w-1/3">
                          {i === 0 && <div>{t(sluggify(stop.action))}</div>}
                          {i > 0 && <div />}
                        </div>
                        <div className="flex flex-row w-2/3">
                          <div className="w-24">
                            <CargomaticInput
                              type="number"
                              placeholder={t('QUANTITY')}
                              min="0"
                              value={l.quantity}
                              onChange={(value) =>
                                this.onLoadQuantityChange(
                                  stops,
                                  stopIndex,
                                  i,
                                  value,
                                )
                              }
                              hideLabel
                            />
                          </div>
                          <div className="pt-2 px-2">{`${t(
                            getLoadTypeText(l.type),
                            { count: 2 },
                          )} ${l.length}x${l.width}x${l.height}`}</div>
                        </div>
                      </div>
                      {i === stop.loads.length - 1 && (
                        <div className="pb-3 mt-2 border-t border-solid border-grey" />
                      )}
                    </div>
                  );
                });
              })}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="button" onClick={this.props.onClose}>
            {t('CANCEL')}
          </button>
          <button
            className="button button-green"
            onClick={() => this.props.onSave(stops)}
          >
            {titleize(t('SAVE'))}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

LoadDistributionModal.propTypes = {
  stops: PropTypes.array.isRequired,
  loads: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default withTranslation()(LoadDistributionModal);
